// removed by extract-text-webpack-plugin
module.exports = {"repHeading":"styles__repHeading__9dYxb","repImg":"styles__repImg__2TDdp","colEighth":"styles__colEighth__1jLQT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Repertoire/styles.scss
// module id = 410
// module chunks = 0